import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from 'react-icheck';
import { Col, FormGroup, HelpBlock } from 'react-bootstrap';
import 'icheck/skins/minimal/grey.css';

const CustomCheckbox = ({ horizontal, checkboxClass, placeholder, labelCol = 3, valueCol = 9, input: { onChange, value }, required, label, staticLabel, help, meta: { touched, error, warning }, ...props }) => {
	const validationState = touched && (error && "error") || (warning && "warning") || null;

	const classes = checkboxClass || 'icheckbox_minimal-grey bg';

	const formControl = <Checkbox checkboxClass={classes} increaseArea='20%' label={label} onChange={e => onChange(e.target.checked)} checked={!!value} {...props} />;
	const errorBlock = touched && (error || warning) && <HelpBlock>{error || warning}</HelpBlock>;
	const helpBlock = help && <HelpBlock>{help}</HelpBlock>;
	const labelHint = required && <em style={{ color: '#D62229' }}>*</em>;

	if (horizontal) {
		return (
			<FormGroup validationState={validationState} className='row'>
				<Col smOffset={labelCol} sm={valueCol}>
					{formControl}{staticLabel}{labelHint}
					{errorBlock}
					{helpBlock}
				</Col>
			</FormGroup>);
	}

	return (
		<FormGroup validationState={validationState}>
			{formControl}{labelHint}
			{errorBlock}
			{helpBlock}
		</FormGroup>
	);
};

CustomCheckbox.propTypes = {
	horizontal: PropTypes.bool,
	checkboxClass: PropTypes.string,
	input: PropTypes.object,
	label: PropTypes.string,
	help: PropTypes.string,
	meta: PropTypes.object,
	placeholder: PropTypes.string,
	disabled: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
	componentClass: PropTypes.string,
	value: PropTypes.string
};

export default CustomCheckbox;